module.exports = __webpack_public_path__ + "img/Katarina_acc_13.5e7495f9.jpg";